export type AuthStrategy =
  | "naa"
  | "office-sso"
  | "msal-browser-popup"
  | "msal-browser-redirect";

export type AuthErrorCode =
  | "USER_CANCELLED"
  | "ACCOUNT_NOT_SUPPORTED"
  | "POPUP_BLOCKED"
  | "CONSENT_REQUIRED"
  | "API_NOT_AVAILABLE"
  | "INTERACTION_REQUIRED"
  | "ALL_STRATEGIES_FAILED"
  | "CONFIG_MISSING"
  | "UNKNOWN";

export class AuthError extends Error {
  public readonly code: AuthErrorCode;
  public readonly strategy?: AuthStrategy;
  public readonly originalError?: unknown;

  constructor(
    code: AuthErrorCode,
    message: string,
    strategy?: AuthStrategy,
    originalError?: unknown
  ) {
    super(message);
    this.name = "AuthError";
    this.code = code;
    this.strategy = strategy;
    this.originalError = originalError;
  }
}
